@use '@design/design-tokens/typography/typography' as *;
@use '@design/design-tokens/border-radius/border-radius' as *;

.skeletonLoaderWrapper {
  width: auto;
}

.secondRowWrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.horizonTitle {
  @include typography-v2-ui-xs;
  color: var(--text-default);
}

.horizonPrefix {
  @include typography-v2-title-sm;
  color: var(--text-soft);
}

.horizonValue {
  @include typography-v2-ui-sm;
  font-family: var(--font-roboto-mono);

  &.negative {
    color: var(--viz-bearish);
  }

  &:not(.negative) {
    color: var(--viz-bullish);
  }
}

.horizonWrapper {
  display: flex;
  flex-direction: column;
  width: 20%;
  text-align: center;
  padding: 4px 0;
  @include border-radius-r1;

  &:hover {
    cursor: pointer;
    background-color: var(--surface-hover);
  }

  &.selected {
    background-color: var(--surface-default);

    &:hover {
      cursor: default;
      background-color: var(--surface-default);
    }
  }
}
